import React from 'react';
import Icon from 'components/AppIcon';
import StatusIndicator from 'components/ui/StatusIndicator';

export default function WelcomeHeader({ volunteer }) {
  const getGreeting = () => {
    const hour = new Date()?.getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 17) return 'Good afternoon';
    return 'Good evening';
  };

  return (
    <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-xl p-6 md:p-8 text-white">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
            <span className="text-white font-heading font-bold text-xl md:text-2xl">
              {volunteer?.name ? volunteer?.name?.charAt(0)?.toUpperCase() : 'V'}
            </span>
          </div>
          <div>
            <p className="text-blue-100 text-sm md:text-base font-caption">{getGreeting()},</p>
            <h1 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-white">
              {volunteer?.name}
            </h1>
            <div className="mt-1.5">
              <StatusIndicator status={volunteer?.status} showTooltip size="sm" />
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 bg-white/10 rounded-lg px-4 py-2 self-start sm:self-auto">
          <Icon name="Calendar" size={16} color="white" />
          <span className="text-white text-sm font-caption">
            Member since {volunteer?.joinDate}
          </span>
        </div>
      </div>
    </div>
  );
}